import { useMemo } from "react";

import { proposalQueryKeys } from "@/lib/query/query-keys";

import type {
  ProposalQueryFilters,
  ProposalSort,
  UseProposalsParams,
} from "./types";

export function useProposalFilters(
  params: UseProposalsParams,
): ProposalQueryFilters {
  return useMemo(
    () => ({
      search: params.search ?? undefined,
      projectId: params.projectId ?? undefined,
      clientId: params.clientId ?? undefined,
      status: params.status ?? undefined,
      ownerId: params.ownerId ?? undefined,
      startDate: params.startDate ?? undefined,
      endDate: params.endDate ?? undefined,
      estimateId: params.estimateId ?? undefined,
      fields: params.fields ?? undefined,
    }),
    [
      params.search,
      params.projectId,
      params.clientId,
      params.status,
      params.ownerId,
      params.startDate,
      params.endDate,
      params.estimateId,
      params.fields,
    ],
  );
}

export function getProposalSort(params: UseProposalsParams): ProposalSort {
  return {
    field: params.sortBy ?? "created_at",
    direction: params.sortOrder ?? "desc",
  };
}

export function getProposalsQueryKey(
  organizationId: string | null,
  filters: ProposalQueryFilters,
  sort: ProposalSort,
  page: number,
  limit: number,
) {
  return proposalQueryKeys.list(
    organizationId ?? undefined,
    filters,
    sort,
    page,
    limit,
  );
}

export interface MetricsFilterParams {
  status?: string;
  projectId?: string;
  estimateId?: string;
  authorId?: string;
  search?: string;
  startDate?: string;
  endDate?: string;
}

export function normalizeMetricsFilters(
  params: MetricsFilterParams,
): ProposalQueryFilters {
  const trimmedSearch = params.search?.trim();
  return {
    status:
      params.status && params.status !== "all" ? params.status : undefined,
    projectId: params.projectId,
    estimateId: params.estimateId,
    ownerId: params.authorId,
    startDate: params.startDate,
    endDate: params.endDate,
    search:
      trimmedSearch && trimmedSearch.length > 0 ? trimmedSearch : undefined,
  };
}
